import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationVerifyVisitor } from "./shared/data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: "app-multi-station-verify-visitor",
	templateUrl: "./multi-station-verify-visitor.component.html",
	styleUrls: ["./multi-station-verify-visitor.component.css"],
})
export class MultiStationVerifyVisitorComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationVerifyVisitor, private activatedRoute: ActivatedRoute, private router: Router) {}

	ngOnInit(): void {
		this.UpdateVisitor();
	}

	//////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////

	VisitorPassID: number = -1;
	SelectedVisitor: any;

	FirstName: string = "N/A";
	LastName: string = "N/A";
	LicenseNbr: string = "N/A";
	State: string = "N/A";
	Address: string = "N/A";
	City: string = "N/A";
	ZipCode: string = "N/A";
	PhoneNbr: string = "N/A";
	Email: string = "N/A";
	VisitorNotes: string = "N/A";
	VisitorPassDTDesc: string = "N/A";
	PassComments: string = "N/A";
	CheckInFacilityName: string = "N/A";
	CheckInFacilityLocationName: string = "N/A";
	VisitorPhoto: string = "";

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////

	UpdateVisitor() {
		//
		// Check Visitor Pass ID
		//

		// Doesn't Exist, Return to main page
		if (this.activatedRoute.snapshot.params.VisitorPassID != undefined) {
			this.VisitorPassID = this.activatedRoute.snapshot.params.VisitorPassID;
		} else {
			this.onBack();
		}

		// Invalid ID
		if (this.VisitorPassID <= 0) {
			this.onBack();
		}

		//
		// Try to load data for the ID
		//
		var result = this.visitorService.VerifyVisitorInfoSelect(this.VisitorPassID);
		result.subscribe(
			(response: any) => {
				console.log(response);

				if (response.Success == false) {
					this.onBack();
					return;
				}

				//
				// Update Display Info
				//
				this.FirstName = response.FirstName;
				this.LastName = response.LastName;
				this.LicenseNbr = response.LicenseNbr;
				this.State = response.State;
				this.Address = response.Address;
				this.City = response.City;
				this.ZipCode = response.ZipCode;
				this.PhoneNbr = response.PhoneNbr;
				this.Email = response.Email;
				this.VisitorNotes = response.VisitorNotes;
				this.VisitorPassDTDesc = response.VisitorPassDTDesc;
				this.PassComments = response.PassComments;
				this.CheckInFacilityName = response.CheckInFacilityName;
				this.CheckInFacilityLocationName = response.CheckInFacilityLocationName;
				this.VisitorPhoto = response.VisitorPhoto;

				this.SelectedVisitor = {
					VisitorPassID: this.VisitorPassID,
					PersonID: response.PersonID,
					FirstName: response.FirstName,
					LastName: response.LastName,
				};
			},
			(error) => {
				this.onBack();
			}
		);
	}

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////

	onBack() {
		this.router.navigate(["/dashboardmultistation"]);
	}

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////
	ClearData() {
		this.FirstName = "N/A";
		this.LastName = "N/A";
		this.LicenseNbr = "N/A";
		this.State = "N/A";
		this.Address = "N/A";
		this.City = "N/A";
		this.ZipCode = "N/A";
		this.PhoneNbr = "N/A";
		this.Email = "N/A";
		this.VisitorNotes = "N/A";
		this.VisitorPassDTDesc = "N/A";
		this.PassComments = "N/A";
		this.CheckInFacilityName = "N/A";
		this.CheckInFacilityLocationName = "N/A";
		this.VisitorPhoto = "N/A";
	}
	//////////////////////////////////////////////
}
